<template>
    <div class="apprentice-simple-card">
        <div class="header">
            <b-button
                class="btn-survey-peer-invite order-1 order-lg-0"
                v-if="hasUninvitedPeers"
                variant="primary"
                @click="openPeerModal">
                <i class="btn-user-add"></i>{{ $t('rubrics.invite_peers') }}
            </b-button>
            <div class="peer-wrapper">
                <h5 class="title">{{ $t('rubrics.the_peers_of_these_rubrics') }}</h5>
                <ul class="peers">
                    <li
                        class="peer-item"
                        v-for="(peer, index) in peers">
                        <b-badge
                            class="badge-peer"
                            variant="info"
                            pill
                            :key="index">
                            {{ peer.user.full_name }}
                        </b-badge>
                    </li>
                </ul>
            </div>
            <div class="student-name order-0 order-lg-1">
                {{ rubricUserIn.user.full_name }}
                <span
                    class="survey-status"
                    v-if="finished">
                    <i class="fas fa-check"></i>
                </span>
            </div>

            <div
                class="survey-user-nav order-2 order-lg-2"
                v-if="studentOptions.length > 1">
                <b-form-select
                    class="apprentice-primary-select"
                    v-model="selectedSurveyUser"
                    :options="studentOptions"
                    @input="viewSelectedSurveyUser">
                </b-form-select>
            </div>
        </div>

        <div>
            <design-2021-rubric-form-component
                id="rubric"
                :rubric-in="currentRubric"
                :rubric-form-in="currentRubric.forms[0]"
                ref="rubric-form-component"
                :edit="edit">
                <template v-slot:options>
                    <b-badge
                        class="survey-steps-badge"
                        pill
                        variant="info">
                        {{ currentRubricNumberOfTotal }} / {{ rubricsIn.length }}
                    </b-badge>
                </template>
            </design-2021-rubric-form-component>
        </div>

        <div class="survey-navigation-and-store">
            <b-button
                class="btn-chevron-left btn-survey-previous-rubric"
                v-if="hasPreviousRubric"
                :variant="!edit ? 'primary' : 'outline-primary'"
                @click="previousRubric">
                <!-- :diabled="!hasPreviousRubric"-->
                {{ $t('common.previous') }}
            </b-button>

            <b-button
                class="btn-save btn-store-survey"
                v-if="edit"
                variant="primary"
                @click="saveCurrentRubric">
                <!--                          v-if="!hasNextRubric && !hasPreviousRubric">-->
                {{ $t('common.save') }}
            </b-button>

            <b-button
                class="btn-after-chevron-right btn-survey-next-rubric"
                v-if="hasNextRubric"
                :variant="!edit ? 'primary' : 'outline-primary'"
                @click="nextRubric"
                ><!-- :diabled="!hasNextRubric"-->
                {{ $t('common.next') }}
            </b-button>
        </div>

        <design-2021-rubric-survey-peer-invite-modal-component
            v-if="hasUninvitedPeers"
            :rubric-type-in="rubricTypeIn"
            :rubric-user-in="rubricUserIn"
            ref="add-peers-modal">
        </design-2021-rubric-survey-peer-invite-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-survey-user-form-edit-component',
    props: ['openRubricUsersIn', 'rubricUserIn', 'rubricsIn', 'edit', 'rubricTypeIn'],

    data() {
        return {
            rubrics: this.rubricsIn,
            peers: this.rubricUserIn.peers,
            currentRubric: this.rubricsIn[0],
            selectedSurveyUser: null,
        };
    },

    computed: {
        hasPreviousRubric() {
            const currentPageIndex = this.rubricsIn.findIndex((rubric) => rubric.id === this.currentRubric.id);
            return currentPageIndex !== 0;
        },

        hasNextRubric() {
            const currentPageIndex = this.rubricsIn.findIndex((rubric) => rubric.id === this.currentRubric.id);
            const nextRubric = this.rubrics[currentPageIndex + 1];
            return nextRubric !== undefined;
        },

        hasNextSurveyUser() {
            return this.openRubricUsersIn.length;
        },

        currentRubricNumberOfTotal() {
            const currentPageIndex = this.rubrics.findIndex((rubric) => rubric.id === this.currentRubric.id);
            return currentPageIndex + 1;
        },

        currentPageIndex() {
            return this.rubrics.findIndex((rubric) => rubric.id === this.currentRubric.id);
        },

        hasUninvitedPeers() {
            if (this.rubricTypeIn === 'rubricSurvey') {
                if (
                    this.rubricUserIn.user_id !== this.$authUser.id ||
                    this.rubricUserIn.rubric_survey.peer_option !== 1
                ) {
                    return false;
                }
                return this.peers.length < this.rubricUserIn.rubric_survey.peer_amount;
            } else if (this.rubricTypeIn === 'assignmentRubric') {
                if (
                    this.rubricUserIn.user_id !== this.$authUser.id ||
                    this.rubricUserIn.assignment_rubric.peer_option !== 1
                ) {
                    return false;
                }

                return this.peers.length < this.rubricUserIn.assignment_rubric.peer_amount;
            }
        },

        finished() {
            for (const rubric of this.rubrics) {
                let myResults = rubric.forms[0].rubric_form_results.find(
                    (result) => result.user_id === this.$authUser.id && result.id,
                );
                if (myResults === undefined) {
                    //this.finished = false
                    return false;
                }
            }
            return true;
        },

        studentOptions() {
            if (this.openRubricUsersIn.length === 0) {
                return [];
            }

            const surveyUsers = this.openRubricUsersIn.map((surveyUser) => {
                return {
                    value: surveyUser.id,
                    text: surveyUser.user.full_name,
                };
            });

            surveyUsers.unshift({
                value: null,
                text: this.$t('rubrics.choose_student'),
            });

            return surveyUsers;
        },
    },

    methods: {
        isEveryQuestionAnswered() {
            const rubricAnswers = this.$refs['rubric-form-component'].getAnswers();
            let rowsLength = 0;

            this.currentRubric.rubric_sections.forEach((section) => {
                rowsLength += section.rubric_rows.length;
            });

            return rubricAnswers.length !== rowsLength;
        },

        nextRubric() {
            if (this.edit) {
                if (this.isEveryQuestionAnswered()) {
                    this.alert
                        .confirm(
                            this.$t('rubrics.incomplete'),
                            this.$t(
                                'rubrics.not_all_question_have_been_answered_only_a_fully_completed_form_will_be_saved_are_you_sure_you_want_to_continue',
                            ),
                            this.$t('rubrics.yes_go_further'),
                            true,
                        )
                        .then((confirm) => {
                            if (!confirm) {
                                return;
                            }
                            this.trueNextRubric();
                        });
                } else {
                    this.saveCurrentRubric();
                    this.trueNextRubric();
                }
            } else {
                this.trueNextRubric();
            }
        },
        trueNextRubric() {
            const currentPageIndex = this.rubrics.findIndex((rubric) => rubric.id === this.currentRubric.id);
            this.currentRubric = this.rubrics[currentPageIndex + 1];
            this.$refs['rubric-form-component'].clear(this.currentRubric, this.currentRubric.forms[0]);
        },

        previousRubric() {
            if (this.edit) {
                if (this.isEveryQuestionAnswered()) {
                    this.alert
                        .confirm(
                            this.$t('rubrics.incomplete'),
                            this.$t(
                                'rubrics.not_all_question_have_been_answered_only_a_fully_completed_form_will_be_saved_are_you_sure_you_want_to_continue',
                            ),
                            this.$t('rubrics.yes_go_further'),
                            true,
                        )
                        .then((confirm) => {
                            if (!confirm) {
                                return;
                            }
                            this.truePreviousRubric();
                        });
                } else {
                    this.saveCurrentRubric();
                    this.truePreviousRubric();
                }
            } else {
                this.truePreviousRubric();
            }
        },
        truePreviousRubric() {
            const currentPageIndex = this.rubrics.findIndex((rubric) => rubric.id === this.currentRubric.id);
            this.currentRubric = this.rubrics[currentPageIndex - 1];
            this.$refs['rubric-form-component'].clear(this.currentRubric, this.currentRubric.forms[0]);
        },
        toNextSurveyUser() {
            if (this.edit) {
                this.saveCurrentRubric();
            }
            window.location.href = this.routes.rubricUserEdit(this.openRubricUsersIn[0].id);
        },

        saveCurrentRubric() {
            const rubricAnswers = this.$refs['rubric-form-component'].getAnswers();
            const rubricFeedback = this.$refs['rubric-form-component'].getFeedback();

            if (this.isEveryQuestionAnswered()) {
                this.alert.warning(
                    this.$t('rubrics.form_not_saved'),
                    this.$t('rubrics.not_all_questions_have_been_answered'),
                );
                return;
            }

            let data = {
                answers: rubricAnswers,
                feedback: rubricFeedback,
            };

            let rubricId = this.currentRubric.id;
            this.alert.saving();
            this.axios.post(this.routes.updateRubricAnswer(this.currentRubric.forms[0].id), data).then(
                (response) => {
                    this.rubrics = this.rubrics.map((rubric2) => {
                        if (rubric2.id !== rubricId) {
                            return rubric2;
                        }
                        let alreadyExistingResult = false;
                        rubric2.forms[0].rubric_form_results = rubric2.forms[0].rubric_form_results.map((results) => {
                            if (results.user_id !== this.$authUser.id) {
                                return results;
                            }
                            alreadyExistingResult = true;
                            return response.data.rubric_form_results[0];
                        });
                        if (!alreadyExistingResult) {
                            rubric2.forms[0].rubric_form_results.push(response.data.rubric_form_results[0]);
                        }
                        rubric2.rubric_sections = rubric2.rubric_sections.map((section) => {
                            section.rubric_rows.map((row) => {
                                row.answers.map((answer) => {
                                    if (answer.user_id !== this.$authUser.id) {
                                        return answer;
                                    } else {
                                        return response.data.rubric_answers.find(
                                            (answer2) => answer2.row_id === row.id,
                                        );
                                    }
                                });
                                return row;
                            });
                            return section;
                        });
                        return rubric2;
                    });
                    let status = 1;
                    if (this.rubricTypeIn === 'assignmentRubric') {
                        status = this.rubricUserIn.assignment_rubric.assignment.statuses[0]
                            ? this.rubricUserIn.assignment_rubric.assignment.statuses[0].finished
                            : 0;
                    }
                    if (this.finished && status !== 1 && this.$authUser.id === this.rubricUserIn.user_id) {
                        this.submitAssignment();
                    } else {
                        this.alert.success();
                    }
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        submitAssignment() {
            let data = {
                assignment_id: this.rubricUserIn.assignment_rubric.assignment_id,
                project_id: this.rubricUserIn.project_id,
            };
            this.axios.post(this.routes.rubricAssignmentStatusSubmit(), data).then(
                (response) => {
                    this.alert.success(this.$t('rubrics.assignment_submitted'));
                    if (this.$authUser.isStudent()) {
                        window.location.href = this.routes.portfolioShow(this.rubricUserIn.project_id);
                    }
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        openPeerModal() {
            this.$refs['add-peers-modal'].show();
        },

        viewSelectedSurveyUser(userId) {
            switch (this.rubricTypeIn) {
                case 'rubricSurvey':
                    window.location.href = this.routes.rubricSurveyUserEdit(userId);
                    break;
                case 'assignmentRubric':
                    window.location.href = this.routes.assignmentRubricEdit(userId);
                    break;
            }
        },
    },
};
</script>

<style scoped lang="scss">
select {
    margin-bottom: 0;
}

.header,
.student-name,
.survey-status,
.steps,
.btn-survey-peer-invite {
    display: flex;
    align-items: center;
    justify-content: center;
}

.header {
    flex-wrap: wrap;
    row-gap: map-get($grid-gutter-spacing, 'fifteen');
    justify-content: space-evenly;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.student-name {
    font-size: 1.5625rem;
    font-weight: $font-weight-bold;
    color: $primary;
    flex: 1 0 100%;
}

.btn-survey-peer-invite,
.survey-user-nav {
    width: 100%;
}

.btn-survey-peer-invite {
    justify-content: space-between;
    column-gap: map-get($grid-gutter-spacing, 'eight');
}

.survey-status {
    font-size: 1.125rem;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: $success;
    color: $white;
    margin-left: map-get($grid-gutter-spacing, 'fifteen');
}

.survey-steps-badge {
    font-size: $base-font-size;
    font-weight: $font-weight-bold;
}

.survey-navigation-and-store {
    .btn {
        width: 100%;

        &:not(:last-child) {
            margin-bottm: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}

.peer-wrapper {
    .title {
        font-weight: $font-weight-bold;
        color: $text-muted-color;
    }

    ul {
        list-style: none;
        padding-left: 0;
        margin-bottom: 0;
        max-height: 145px;
        overflow-y: auto;

        li:not(:last-child) {
            margin-bottom: map-get($grid-gutter-spacing, 'eight');
        }
    }
}

.peers {
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

    .label {
        margin-bottom: 0;
    }

    .badge {
        font-size: 0.75rem;
        padding: map-get($grid-gutter-spacing, 'four') map-get($grid-gutter-spacing, 'eight');
        margin-right: map-get($grid-gutter-spacing, 'ten');
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .btn-survey-peer-invite,
    .survey-user-nav {
        width: auto;
    }

    .survey-user-nav {
        margin-left: auto;
        max-width: 250px;
    }

    .survey-navigation-and-store {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .btn {
            width: auto;

            &:not(:last-child) {
                margin-bottom: 0;
            }
        }
    }

    .btn-store-survey,
    .btn-survey-next-rubric {
        margin-left: auto;
    }

    .btn-store-survey:last-child {
        margin-right: auto;
    }
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .header {
        justify-content: space-evenly;
        column-gap: map-get($grid-gutter-spacing, 'fifteen');
    }

    .student-name {
        flex: 0 0 auto;
        margin-left: auto;
        max-width: calc(60% - 72px);
    }

    .survey-user-nav {
        max-width: 160px;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .survey-user-nav {
        max-width: 230px;
    }
}
</style>
